import React from "react";
import ReactDOM from "react-dom";
import reactToWebComponent from "react-to-webcomponent";
import { ThemeProvider, ThemeContext } from "styled-components";
import PropTypes from "prop-types";

import { ProfileInitials } from "@ibinder/ui-common-core";
import { iBinderMainTheme, ThemeInterface } from "@ibinder/ui-common-styles";

interface ButtonProps {
  imagePath: any;
  size: string;
  label: string;
}

const Index = ({ imagePath = "default", label = "test" }: ButtonProps) => {
  const domRef = React.useRef(null);
  const theme: ThemeInterface = React.useContext(ThemeContext);

  return (
    <div ref={domRef}>
      <ThemeProvider theme={iBinderMainTheme}>
        <ProfileInitials
          firstName={"firstName"}
          lastName={"lastName"}
          size="extraLarge"
        />
      </ThemeProvider>
    </div>
  );
};

Index.propTypes = {
  typeofbutton: PropTypes.string.isRequired
};

customElements.define(
  "ibinder-avatar",
  // @ts-ignore
  reactToWebComponent(Index, React, ReactDOM)
);
